var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');
var Session = require('psa-core/Session');

var Scaffold = require('common/layout/Scaffold');
var ActivePageSection = require('common/util/ActivePageSection');

var COCContactSearchView = require('../views/COCContactSearchView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);
  var searchLimit = Session.config.CM_ELASTICSEARCH_MAX_RESULTS || 1000;

  NavUtils.navigate('coc/dashboard/contact-search');

  Scaffold.content.show(
    new COCContactSearchView({
      model: new Backbone.Model({
        searchLimit: searchLimit
      })
    })
  );

  ActivePageSection.empty();
  NProgress.done();
};
